import React from "react";

import assessmentBuilderHumanReviewShield from "../../images/talentlenz-assessment-builder-human-review-shield.svg";
import assessmentBuilderInterface from "../../images/talentlenz-assessment-builder-interface.svg";
// import assessmentBuilderReviewPhoto from "../../images/talentlenz-assessment-builder-review-photo.jpg";
import assessmentBuilderReviewPhoto from "../../images/assessment-builder-optimized.webp";

import "./TalentLenzAssessmentBuilder.css";

const assessmentMethods = [
  {
    id: "ai-generated",
    label: "AI-generated",
    modifier: "ai",
  },
  {
    id: "uploaded",
    label: "Uploaded",
    modifier: "uploaded",
  },
  {
    id: "hybrid",
    label: "Hybrid",
    modifier: "hybrid",
  },
];

export default function TalentLenzAssessmentBuilder() {
  return (
    <section
      id="talentlenz-assess"
      className="talentlenz-assessment-builder"
      aria-labelledby="talentlenz-assessment-builder-title"
    >
      <div className="talentlenz-assessment-builder__inner">
        <div className="talentlenz-assessment-builder__copy">
          <p className="talentlenz-assessment-builder__eyebrow">
            Build the assessment
          </p>

          <h2
            id="talentlenz-assessment-builder-title"
            className="talentlenz-assessment-builder__title"
            aria-label="Assess what the opportunity actually requires."
          >
            <span
              className="talentlenz-assessment-builder__title-layout talentlenz-assessment-builder__title-layout--desktop"
              aria-hidden="true"
            >
              Assess what the
              <br />
              opportunity actually
              <br />
              requires.
            </span>

            <span
              className="talentlenz-assessment-builder__title-layout talentlenz-assessment-builder__title-layout--landscape"
              aria-hidden="true"
            >
              Assess what the
              <br />
              opportunity
              <br />
              actually requires.
            </span>

            <span
              className="talentlenz-assessment-builder__title-layout talentlenz-assessment-builder__title-layout--portrait"
              aria-hidden="true"
            >
              Assess what the opportunity
              <br />
              actually requires.
            </span>

            <span
              className="talentlenz-assessment-builder__title-layout talentlenz-assessment-builder__title-layout--mobile"
              aria-hidden="true"
            >
              Assess what the
              <br />
              opportunity
              <br />
              actually requires.
            </span>
          </h2>

          <p
            className="talentlenz-assessment-builder__description"
            aria-label="Generate technical and workplace-awareness questions with AI, upload your own assessment, or combine both. Your team reviews every question before applicants see it."
          >
            <span
              className="talentlenz-assessment-builder__description-layout talentlenz-assessment-builder__description-layout--desktop"
              aria-hidden="true"
            >
              Generate technical and workplace-awareness questions
              <br />
              with AI, upload your own assessment, or combine both.
              <br />
              Your team reviews every question before applicants see it.
            </span>

            <span
              className="talentlenz-assessment-builder__description-layout talentlenz-assessment-builder__description-layout--landscape"
              aria-hidden="true"
            >
              Generate questions with AI, upload your own
              <br />
              assessment, or combine both. Your team
              <br />
              reviews every question before applicants see it.
            </span>

            <span
              className="talentlenz-assessment-builder__description-layout talentlenz-assessment-builder__description-layout--portrait"
              aria-hidden="true"
            >
              Generate technical and workplace-awareness questions with AI,
              <br />
              upload your own assessment, or combine both. Your team reviews
              <br />
              every question before applicants see it.
            </span>

            <span
              className="talentlenz-assessment-builder__description-layout talentlenz-assessment-builder__description-layout--mobile"
              aria-hidden="true"
            >
              Generate questions with AI, upload your own
              <br />
              assessment, or combine both. Your team
              <br />
              reviews every question before applicants
              <br />
              see it.
            </span>
          </p>

          <ul
            className="talentlenz-assessment-builder__methods"
            aria-label="Assessment creation options"
          >
            {assessmentMethods.map((method) => (
              <li
                key={method.id}
                className={`talentlenz-assessment-builder__method talentlenz-assessment-builder__method--${method.modifier}`}
              >
                <span
                  className="talentlenz-assessment-builder__method-dot"
                  aria-hidden="true"
                />

                <span>{method.label}</span>
              </li>
            ))}
          </ul>
        </div>

        <figure className="talentlenz-assessment-builder__media">
          <div className="talentlenz-assessment-builder__photo-frame">
            <img
              className="talentlenz-assessment-builder__photo"
              src={assessmentBuilderReviewPhoto}
              alt="Two HR team members reviewing an opportunity-specific assessment."
              width="1536"
              height="1024"
              loading="lazy"
              decoding="async"
              draggable="false"
            />
          </div>

          <span
            className="talentlenz-assessment-builder__interface-backdrop"
            aria-hidden="true"
          />

          <img
            className="talentlenz-assessment-builder__interface"
            src={assessmentBuilderInterface}
            alt="TalentLenz assessment builder showing AI generation, uploaded assessments, hybrid mode and HR approval status."
            width="760"
            height="390"
            decoding="async"
            draggable="false"
          />
        </figure>

        <div
          className="talentlenz-assessment-builder__review"
          role="note"
          aria-label="Control stays with your team. Human-reviewed before publication."
        >
          <img
            className="talentlenz-assessment-builder__review-icon"
            src={assessmentBuilderHumanReviewShield}
            alt=""
            width="56"
            height="56"
            aria-hidden="true"
            draggable="false"
          />

          <div className="talentlenz-assessment-builder__review-copy">
            <span className="talentlenz-assessment-builder__review-label">
              Control stays with your team
            </span>

            <p className="talentlenz-assessment-builder__review-text">
              Human-reviewed before{" "}
              <br className="talentlenz-assessment-builder__review-mobile-break" />
              publication.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}